<template>
  <div v-if="critereRecherche" class="tableWithPerPageSelection">
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="haveSelectedRelance"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-3  is-5-fullhd pdr-0 pdl-0">
            <b-input :placeholder="$t('relanceSave.actions.search')" type="search" icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('relanceSave.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permissionsRelances.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
            @endLoadParamtre="arrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <a ref="lienDownload"></a>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="arrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <div slot="selected" class="has-text-centered" slot-scope="props">
        <qd-checkbox v-model="props.row.selected"
                    @input="selectRelance()"
        ></qd-checkbox>
      </div>
      <div slot="relanceLibelle" slot-scope="props"
           :class="{ 'textDecorationLineThrough': !props.row.actif }">
        <router-link :to="{ name: 'c.bodac.relance',
          params: { relanceId: props.row.id }}"
                     class="lien"
                     :class="{'text-access-no-permission':
                     !checkPermissions(permissionsRelances.lecture)}">
          {{ props.row.relanceLibelle }}
        </router-link>
      </div>
      <div slot="dateRelance" slot-scope="props"
           :class="{ 'textDecorationLineThrough': !props.row.actif }">
        {{ props.row.dateRelance | formatDate }}
      </div>
      <div slot="dateFacture" slot-scope="props"
           :class="{ 'textDecorationLineThrough': !props.row.actif }">
       <p v-if="getFactures(props.row.mouvementsClients).ids.length === 1">
          {{ props.row.mouvementsClients[0].facture.date | formatDate }}
        </p>
        <div v-else  class="lien is-cursor-pointer"
          @click="actionOnClick(props.row.mouvementsClients)">
          {{ $t('listeRelanceForClient.multiFacture') }}</div>
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(getEtat(props.row.etat)) }}
      </div>
      <div slot="payeur" slot-scope="props"
        :class="{ 'textDecorationLineThrough': !props.row.actif }">
        <section class="is-flex is-justify-content-space-between">
          {{ props.row.payeur.nomCommercial }}
          <niveau-blocage-icone
          v-if="props.row.payeurBlocageLevel"
          :niveau="props.row.payeurBlocageLevel"
          :description="props.row.payeurDescriptionBlocage"
         />
       </section>
      <div>{{ props.row.payeur.telephone }}</div>
      </div>
      <template slot="annonceurs" slot-scope="props">
          <div :class="{ 'textDecorationLineThrough': !props.row.actif }">
            {{ getAnnonceurs(props.row) }}
          </div>
      </template>
      <div slot="compteComptable" slot-scope="props"
           :class="{ 'textDecorationLineThrough': !props.row.actif }">
        {{ props.row.payeur.compteComptable }}
      </div>
      <div slot="facture" slot-scope="props"
           :class="{ 'textDecorationLineThrough': !props.row.actif }">
        <router-link-blank v-if="getFactures(props.row.mouvementsClients).ids.length === 1"
          :to="{ name: 'c.bodac.factures',
          params: { id: getFactures(props.row.mouvementsClients).ids[0] } }"
          :message="getFactures(props.row.mouvementsClients).codes"/>
        <div v-else  class="lien is-cursor-pointer"
          @click="actionOnClick(props.row.mouvementsClients)">
          {{ $t('listeRelanceForClient.multiFacture') }}</div>
      </div>
      <div slot="montant" slot-scope="props" class="is-pulled-right"
           :class="{ 'textDecorationLineThrough': !props.row.actif }">
        {{ getMontantRelance(props.row.mouvementsClients) | formatDevise }}
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAllAgenceLibelle(props.row.mouvementsClients) }}
      </div>
      <div slot="commentaire" slot-scope="props">
        <commentaireListInput
          :id="props.row.id"
          v-model="props.row.commentaire"
          :maj="majCom">
        </commentaireListInput>
      </div>
      <div slot="actif" slot-scope="props">
        <div>{{ props.row.actif ? $t('general.non') : $t('general.oui') }}</div>
      </div>
      <div slot="exporter" slot-scope="props" >
        <a @click="checkPermissions(permissionsRelances.editer) ?
          edition(pdf, props.row.id) : showPopUp()">
          <b-icon
            :key="props.id"
            icon="file-pdf-box"
            type="is-primary"
            :class="{'text-access-no-permission' :
            !checkPermissions(permissionsRelances.editer)}">
          </b-icon>
        </a>
      </div>
      <div class="has-text-centered" slot="modifier" slot-scope="props">
        <a
           @click="checkPermissions(permissionsRelances.maj) ?
           $router.push({
           name: 'm.bodac.relance-edition', params: { id: props.row.id }}) : showPopUp()">
          <b-icon
            icon="pencil-box-outline"
            type="is-success"
            :class="{ 'text-access-no-permission' : !checkPermissions(permissionsRelances.maj) }"
          >
          </b-icon>
        </a>
      </div>
      <div slot="archive" slot-scope="props" class="has-text-centered">
        <a @click="checkPermissions(permissionsRelances.supprimer) ?
          openPopUpArchivage(props.row) : showPopUp()">
          <b-icon :icon="props.row.actif ? 'archive' : 'archive-arrow-up'"
                  type="is-default"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permissionsRelances.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
      <div class="has-text-centered" slot="supprimer" slot-scope="props">
        <a @click="checkPermissions(permissionsRelances.supprimer) ?
          openPopUpDelete(props.row.id) : showPopUp()">
          <b-icon
            icon="delete-forever"
            type="is-danger"
            :class="{ 'text-access-no-permission' :
            !checkPermissions(permissionsRelances.supprimer) }">
          </b-icon>
        </a>
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-relance ref="filtreRelance"
        :is-from-relance-save="true"
        @toggleFiltre="setShowFiltre"
        @recherche="makeRechercheFilter()"/>
    </div>
    <b-modal
      v-model="afficherListeFactures"
      has-modal-card
      class="modal">
      <pop-up-mouvement-clients-facture
        :mouvementsClients="mouvementsClientsDeLaRelance"
        @close="afficherListeFactures = false">
      </pop-up-mouvement-clients-facture>
    </b-modal>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="idRelanceToDelete.length === 1
          ? $t('relanceSave.popUpSuppression.title')
          : $t('relanceSave.popUpSuppression.titleMutlti')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteRelance()">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpArchivage" has-modal-card class="modal">
      <pop-up-prevention @yes="archiverRelance"
                         @no="popUpArchivage = false"
                         :messHeader="$t(relanceToArchive.libelle)"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="{}"
        :choiceEdition=[]
        @editionChoose="edition"
      >
      </pop-up-edition>
    </b-modal>
    <b-modal v-model="popUpPrevention" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t(messagesActionSelected.titlePopup)"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpPrevention = false"
        @yes="updateEatRelances()">
      </pop-up-prevention>
    </b-modal>
    <b-modal
      v-model="popUpRelancerEnMasse"
      :can-cancel="!isSendingMail"
      class="modal"
      width="1600px"
      has-modal-card>
      <pop-up-relancer-en-masse
        :relances="itemsSelected"
        :sending-mail-in-progress.sync="isSendingMail"
        @close="closeEmailEnMasse">
      </pop-up-relancer-en-masse>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import { RELANCE } from '@/configuration/permissionsBodacConf';
import formatIsoDate from '@/services/general/formatIsoDate';
import * as relanceConf from '@/configuration/relances/relancesConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import PopUpPrevention from '@/components/general/popUpPrevention';
import {
  updateEtat, archiver,
  deleteAll, commenter,
} from '@/api/relances/index';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import filtreRelance from '@/components/relances/filtreRelance';
import * as types from '@/store/modules/relance-mutation-type';
import selecteurAction from '@/components/general/selecteurAction';
import {
  ACTION_ENVOYER,
  ACTION_MASS_ARCHIVER,
  ACTION_MASS_DESARCHIVER,
  ACTION_MASS_EDITION,
  ACTION_MASS_DELETE,
  ACTION_MASS_ENREGISTRER,
} from '@/configuration/general/actionsConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import { columnsSplice } from '@/services/general/columns';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import edition from '@/api/edition';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { REFERENCE_TABLE_RELANCE_SAVE } from '@/configuration/general/referenceTableConf';
import parametrageTable from '@/components/general/parametrageTable';
import popUpMouvementClientsFacture from '@/components/relances/p_mouvementClientsFacture';
import popUpEdition from '@/components/factures/p_edition';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import commentaireListInput from '@/components/general/input/commentaireListInput/commentaireListInput';
import transformerRelance from '@/services/relances/filter/relancesServerTableDataTransformer';
import NiveauBlocageIcone from '@/components/general/NiveauBlocageIcone';
import uniq from 'lodash/uniq';
import PopUpRelancerEnMasse from '@/components/relances/relanceMailEnMasse/popUpRelancerEnMasse';

const relance = createNamespacedHelpers('relance');
const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      permissionsRelances: RELANCE,
      allRelanceSelected: false,
      unsubscribeValue: null,
      showFiltre: false,
      arrayRendering: false,
      mountedLoadingEnd: false,
      pdf: TYPE_PDF,
      typeEditionRelance: relanceConf.TYPE_EDITION_RELANCE,
      actions: [
        { action: ACTION_ENVOYER, translation: 'relanceSave.actions.envoyer' },
        { action: ACTION_MASS_DELETE, translation: 'relanceSave.actions.supprimer' },
        { action: ACTION_MASS_ARCHIVER, translation: 'relanceSave.actions.archiver' },
        { action: ACTION_MASS_DESARCHIVER, translation: 'relanceSave.actions.desarchiver' },
        { action: ACTION_MASS_EDITION, translation: 'relanceSave.actions.editionMasse' },
        { action: ACTION_MASS_ENREGISTRER, translation: 'relanceSave.actions.enregistrer' },
        { action: relanceConf.ACTION_ENVOYER_PAR_MAIL, translation: 'relanceSave.actions.envoyerParMail' },
      ],
      referenceTable: REFERENCE_TABLE_RELANCE_SAVE,
      afficherListeFactures: false,
      mouvementsClientsDeLaRelance: null,
      popUpSuppression: false,
      idRelanceToDelete: [],
      popUpArchivage: false,
      relanceToArchive: {
        archive: false,
        libelle: null,
        libelleSuccess: null,
        ids: [],
      },
      popUpEdition: false,
      popUpPrevention: false,
      actionSelected: null,
      popUpRelancerEnMasse: false,
      isSendingMail: false,
    };
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key]);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageGescom.retard.listeRelanceSave'));
      if (this.$route.params.tiersId) {
        this.critereRecherche.tiersId.push(this.$route.params.tiersId);
      }
      await updateCritereWithParametreInterne(this.critereRecherche);
      this.critereRecherche.agenceIdFacture = this.agencesSelectionnees
        .map((agence) => agence.agenceId);
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  components: {
    routerLinkBlank,
    PopUpPrevention,
    filtreRelance,
    selecteurAction,
    TableItemsInView,
    parametrageTable,
    popUpMouvementClientsFacture,
    popUpEdition,
    exportExcelButton,
    commentaireListInput,
    NiveauBlocageIcone,
    PopUpRelancerEnMasse,
  },
  methods: {
    ...relance.mapMutations({
      setCritereRecherche: types.SET_CRITERE,
    }),
    ...relance.mapActions({
      actionsLoadRelances: 'loadRelances',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    majCom(id, commentaire) {
      return commenter({
        id: id,
        commentaire: commentaire,
      });
    },
    getAnnonceurs(relance) {
      return uniq(relance.mouvementsClients.flatMap(m => m.facture.annonceurs)).join(', ');
    },
    async edition(format, id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const ids = id ? [id] : this.items.filter((relance) => {
          return relance.selected;
        }).map(relance => relance.id);
        const response = await edition({
          ids: ids,
          extension: format,
          typeDonnee: this.typeEditionRelance,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreRelance.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    updateAgenceAndRecherche() {
      this.critereRecherche.agenceIdFacture = this.agencesSelectionnees
        .map((agence) => agence.agenceId);
      this.recherche();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    getAllAgenceLibelle(mouvementClients) {
      const agencesIds = [...new Set(mouvementClients
        .map(mvt => mvt.facture.agenceId))];
      const agences = this.agencesSelectionnees
        .filter(a => agencesIds.includes(a.agenceId));
      return agences.map(a => a.libelleAgence).join(', ');
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    getEtat(etatRelance) {
      const etat = relanceConf.ETAT_RELANCES.find((el) => {
        return etatRelance === el.etat;
      });
      return etat.libelle;
    },
    selectRelance() {
      this.allRelanceSelected = this.items.filter((el) => {
        return el.selected;
      }).length === this.items.length;
    },
    selectAll() {
      this.allRelanceSelected = !this.allRelanceSelected;
      this.items.forEach((el) => {
        el.selected = this.allRelanceSelected;
      });
    },
    async updateEatRelances() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const relancesIds = this.items.filter(r => r.selected).map(r => r.id);
        await updateEtat({ relancesIds, etat: this.messagesActionSelected.etat });
        this.popUpPrevention = false;
        messageSucces(this.$t(
          this.messagesActionSelected.messageSuccess,
          { number: relancesIds.length }),
        );
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        this.popUpPrevention = false;
        messageErreur(this.$i18n);
        loadingComponent.close();
      }
    },
    handleAction(action) {
      this.actionSelected = action;
      switch (action) {
        case ACTION_ENVOYER:
          if (this.checkPermissions(this.permissionsRelances.maj)) {
            this.popUpPrevention = true;
          } else this.showPopUp();
          break;
        case ACTION_MASS_ARCHIVER:
          if (this.checkPermissions(this.permissionsRelances.maj)) {
            this.openPopUpArchivageMulti(false);
          } else this.showPopUp();
          break;
        case ACTION_MASS_DESARCHIVER:
          if (this.checkPermissions(this.permissionsRelances.maj)) {
            this.openPopUpArchivageMulti(true);
          } else this.showPopUp();
          break;
        case ACTION_MASS_EDITION:
          if (this.checkPermissions(this.permissionsRelances.editer)) {
            this.popUpEdition = true;
          } else this.showPopUp();
          break;
        case ACTION_MASS_ENREGISTRER:
          if (this.checkPermissions(this.permissionsRelances.maj)) {
            this.popUpPrevention = true;
          } else this.showPopUp();
          break;
        case relanceConf.ACTION_ENVOYER_PAR_MAIL:
          this.popUpRelancerEnMasse = true;
          break;
        default:
          break;
      }
      if (action === ACTION_MASS_DELETE) {
        if (this.checkPermissions(this.permissionsRelances.supprimer)) {
          this.popUpSuppression = true;
          this.idRelanceToDelete = this.items.filter((relance) => {
            return relance.selected;
          }).map(relance => relance.id);
        } else this.showPopUp();
      }
    },
    async reinitialiser() {
      await this.$refs.filtreRelance.initializeFiltre();
      await this.$refs.filtreRelance.viderCritere();
      this.$refs.filtreRelance.appliquerCritere();
      this.showFiltre = false;
    },
    getMontantRelance(mouvementClients) {
      return mouvementClients.map(mvt => mvt.montantEcheance)
        .reduce((a, b) => a + b, 0);
    },
    getFactures(mouvementClients) {
      const codes = [...new Set(mouvementClients.map(mvt => {
        return mvt.facture.code;
      }))].join(',');
      const ids = [...new Set(mouvementClients.map(mvt => {
        return mvt.facture.id;
      }))];
      return { codes, ids };
    },
    actionOnClick(mouvementsClients) {
      this.mouvementsClientsDeLaRelance = mouvementsClients;
      this.afficherListeFactures = true;
    },
    closeEmailEnMasse() {
      this.recherche();
      this.popUpRelancerEnMasse = false;
    },
    openPopUpDelete(relanceId) {
      this.idRelanceToDelete = [relanceId];
      this.popUpSuppression = true;
    },
    async deleteRelance() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteAll({
          ids: this.idRelanceToDelete,
        });
        messageSucces(this.idRelanceToDelete.length === 1
          ? this.$t('relanceSave.popUpSuppression.success.oneRelance') : this.$t('relanceSave.popUpSuppression.success.relanceMulti'));
        loadingComponent.close();
        this.popUpSuppression = false;
        this.recherche();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
      }
    },
    openPopUpArchivage(relance) {
      this.relanceToArchive = {
        archive: !relance.actif,
        libelle: relance.actif ? 'relanceSave.archivageDesarchiver.archivage' : 'relanceSave.archivageDesarchiver.desarchivage',
        libelleSuccess: relance.actif ? 'relanceSave.messages.success.archivage' : 'relanceSave.messages.success.desarchivage',
        ids: [relance.id],
      };
      this.popUpArchivage = true;
    },
    openPopUpArchivageMulti(archive) {
      const ids = this.items.filter((relance) => {
        return relance.selected;
      }).map(relance => relance.id);
      this.relanceToArchive = {
        archive: archive,
        libelle: archive ? 'relanceSave.archivageDesarchiver.desarchivageMulti' : 'relanceSave.archivageDesarchiver.archivageMulti',
        libelleSuccess: archive ? 'relanceSave.messages.success.desarchivageMulti' : 'relanceSave.messages.success.archivageMulti',
        ids: ids,
      };
      this.popUpArchivage = true;
    },
    async archiverRelance() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.popUpArchivage = false;
        await archiver(this.relanceToArchive.ids, this.relanceToArchive.archive);
        messageSucces(this.$i18n.t(this.relanceToArchive.libelleSuccess));
        this.relanceToArchive = {
          archive: false,
          libelle: null,
          libelleSuccess: null,
          ids: [],
        };
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  computed: {
    ...relance.mapGetters({
      items: 'items',
      totalCount: 'totalCount',
      getCriteresRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    critereRecherche: {
      get() {
        return this.getCriteresRecherche;
      },
      set(value) {
        return this.setCritereRecherche(value);
      },
    },
    haveSelectedRelance() {
      return this.items.filter((el) => {
        return el.selected;
      }).length > 0;
    },
    itemsSelected() {
      return this.items.filter((el) => el.selected);
    },
    columns() {
      const columns = ['selected', 'relanceLibelle', 'dateRelance', 'etat', 'facture', 'dateFacture', 'payeur', 'annonceurs', 'compteComptable', 'montant', 'agence', 'commentaire', 'actif', 'exporter', 'modifier', 'archive', 'supprimer'];
      if (this.societeActive.agences.length === 1) {
        columnsSplice(columns, 'agence');
      }
      return columns;
    },
    iconSelectTotal() {
      if (this.allRelanceSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    nombreCritere() {
      const banCritere = ['date', 'societeId', 'datesFacture', 'datesRelance', 'actif'];
      if (this.societeActive.agences.length === 1) banCritere.push('agenceIdFacture');
      let nbFiltre = calculNombreCritere(this.critereRecherche, banCritere);

      if (this.critereRecherche.datesFacture.dateDebut
        || this.critereRecherche.datesFacture.dateFin) nbFiltre += 1;
      if (this.critereRecherche.datesRelance.dateDebut
        || this.critereRecherche.datesRelance.dateFin) nbFiltre += 1;
      nbFiltre += this.critereRecherche.actif !== null ? 1 : 0;
      nbFiltre += this.critereRecherche.codeFacture ? 1 : 0;
      if (nbFiltre > 9) return '9+';
      return nbFiltre;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          relanceLibelle: this.$i18n.t('relanceSave.tab.numberRelance'),
          dateRelance: this.$i18n.t('relanceSave.tab.dateRelance'),
          etat: this.$i18n.t('relanceSave.tab.etat'),
          facture: this.$i18n.t('relanceSave.tab.numberFacture'),
          dateFacture: this.$i18n.t('relanceSave.tab.dateFacture'),
          payeur: this.$i18n.t('relanceSave.tab.payeur'),
          annonceurs: this.$i18n.t('relanceSave.tab.annonceurs'),
          montant: this.$i18n.t('relanceSave.tab.montant'),
          compteComptable: this.$i18n.t('relance.compteComptable'),
          agence: this.$i18n.t('relanceSave.tab.agence'),
          actif: this.$i18n.t('relanceSave.tab.archive'),
          commentaire: this.$i18n.t('relanceSave.tab.commentaire'),
          modifier: '',
          exporter: '',
          archive: '',
          supprimer: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        requestFunction: ((data) => {
          if (this.critereRecherche.agenceIdFacture.length === 0) {
            this.critereRecherche.agenceIdFacture = this.agencesSelectionnees
              .map((agence) => agence.agenceId);
          }
          data.query = cloneDeep(this.critereRecherche);
          data.query.datesFacture.dateDebut = formatIsoDate(data.query.datesFacture.dateDebut);
          data.query.datesFacture.dateFin = formatIsoDate(data.query.datesFacture.dateFin);
          data.query.datesRelance.dateDebut = formatIsoDate(data.query.datesRelance.dateDebut);
          data.query.datesRelance.dateFin = formatIsoDate(data.query.datesRelance.dateFin);
          data.query.date = formatIsoDate(new Date());
          data.query.societeId = this.societeActiveId;
          if (data.query.payeurs.length > 0) {
            data.query.tiersId = data.query.payeurs.map((payeur) => {
              return payeur.id;
            });
          }
          delete data.query.payeurs;
          return this.actionsLoadRelances(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        sortable: ['dateRelance', 'etat'],
        columnsClasses: {
          exporter: 'colonneSelected',
          selected: 'colonneSelected',
          supprimer: 'colonneSelected',
          modifier: 'colonneSelected',
          archive: 'colonneSelected',
          commentaire: 'colonneWidth250px',
        },
      };
    },
    messagesActionSelected() {
      let titlePopp = '';
      const relancesIds = this.items.filter(r => r.selected).map(r => r.id);
      switch (this.actionSelected) {
        case ACTION_ENVOYER:
          titlePopp = relancesIds.length > 1 ? 'titleEnvoyeRelances' : 'titleEnvoyeRelance';
          return {
            titlePopup: `relanceSave.popUpConf.${titlePopp}`,
            messageSuccess: 'relanceSave.confEnvoie',
            etat: relanceConf.ENVOYE,
          };
        case ACTION_MASS_ENREGISTRER:
          titlePopp = relancesIds.length > 1 ? 'titleEnregistreRelances' : 'titleEnregistreRelance';
          return {
            titlePopup: `relanceSave.popUpConf.${titlePopp}`,
            messageSuccess: 'relanceSave.confEnregistre',
            etat: relanceConf.ENREGISTRE,
          };
        default:
          return {};
      }
    },
    exportExcelQuery() {
      return {
        typeDonnee: relanceConf.EXPORT_EXCEL_RELANCE,
        typeExport: null,
        filtres: transformerRelance(this.lastPayload),
      };
    },
  },
};
</script>

<style scoped>

</style>
